import React from "react";
import "./index.css";
import cn from "classnames";
import BgTransformer from "../../../layout/BgTransformer";
import BannerButton from "../../../layout/BannerButton";
import PixelationLayer from "../../../layout/PixelationLayer";
import Textarea from "../../../layout/Textarea/Textarea";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import {useSetting} from "../../../contexts/setting";
import {useBgUrl} from "hooks/useBgUrl";
import AirBanner, {isAirBanner} from "pages/Releases/AirBanner";
import {useEdits} from "../../../contexts/edits";
import {PLACEHOLDERS} from "../../../data/constants";

const Email01 = ({id, zoom}) => {
  const {product, channel} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {subtitles2, badges, versions, productNames} = useEdits();

  const defaultProductName = product.altLabel || product.label;
  const productName = productNames[id] || productNames.main || defaultProductName;
  const subtitleText = subtitles2[id] ?? subtitles2.main ?? PLACEHOLDERS.en.subtitle;
  const badgeText = badges[id] ?? badges.main ?? PLACEHOLDERS.en.button;
  const versionText = versions[id] ?? versions.main ?? PLACEHOLDERS.en.version;

  // JetBrains Air replaces the whole banner rather than restyling this one:
  // every channel that lists the product draws the same skin (src/data/offering.ts).
  if (isAirBanner(product.value)) {
    return <AirBanner id={id} zoom={zoom} copy="email" />;
  }

  return (
    <div
      id={id}
      className={cn("template", product.value, "release_email01")}
      style={{"--zoom-level": zoom}}
    >
      <div>
        <BgTransformer src={bgUrl} id={id} />
        <PixelationLayer />
        <div className="content">
          <div className="main-text">
            <div className="product-name">
              <ContentEditable id={id} text={productName} />
            </div>
            <div className="subtitle2">
              <Textarea id={id} text={subtitleText} />
            </div>
            <BannerButton id={id} className="download-badge">
              <div className="badge">
                <Textarea id={id} text={badgeText} inline={true} />
              </div>
            </BannerButton>
            <div className="version-wrap">
              <div className="version">
                <Textarea id={id} text={versionText} inline={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Email01;
